import { configureStore } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import { createStateSyncMiddleware, initMessageListener } from "redux-state-sync";
import storage from 'redux-persist/lib/storage'
import userReducer from './userSlice'
import fileUploadReducer from './fileUploadSlice'
import uiReducer from './uiSlice'
import notificationsReducer from './notificationsSlice'
import timelineReducer from './timelineSlice'

const persistConfig = {
  key: 'root',
  storage,
}

const persistedUserReducer = persistReducer(persistConfig, userReducer)
// Removed persistence for fileUploadReducer - data will not be stored in localStorage
const persistedNotificationsReducer = persistReducer(persistConfig, notificationsReducer)

const syncConfig = {
  // Only whitelist user slice to sync between tabs
  whitelist: ['user']
}

export const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    fileUpload: fileUploadReducer, // No longer persisted
    notifications: persistedNotificationsReducer,
    ui: uiReducer,
    timeline: timelineReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware(
      {
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }
    ).concat(createStateSyncMiddleware(syncConfig)),
})

initMessageListener(store);

export const persistor = persistStore(store)